// removed by extract-text-webpack-plugin
module.exports = {"sf-checkbox":"Checkbox__sf-checkbox___2fwJa"};